/* CL Core – tiny, dependency-free behaviours. Safe to load multiple times. */
(function(){
  if (window.__clCore) return; window.__clCore = true;

  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-cl-acc-trigger]');
    if (!b) return;
    var item = b.closest('[data-cl-acc]');
    var open = b.getAttribute('aria-expanded') === 'true';
    if (item && item.dataset.clSingle === 'true'){
      var root = item.parentElement;
      root.querySelectorAll('[data-cl-acc-trigger][aria-expanded="true"]').forEach(function(o){
        if (o !== b){ o.setAttribute('aria-expanded','false'); var p = o.parentElement.querySelector('[data-cl-panel]'); if(p) p.style.height = '0px'; }
      });
    }
    b.setAttribute('aria-expanded', String(!open));
    var panel = item.querySelector('[data-cl-panel]');
    if (panel) panel.style.height = open ? '0px' : panel.scrollHeight + 'px';
  });

  document.addEventListener('click', function(e){
    var t = e.target.closest('[data-cl-tab]');
    if (!t) return;
    var root = t.closest('[data-cl-tabs]');
    root.querySelectorAll('[data-cl-tab]').forEach(function(x){ x.setAttribute('aria-selected', String(x === t)); });
    root.querySelectorAll('[data-cl-tabpanel]').forEach(function(p){ p.hidden = p.dataset.clTabpanel !== t.dataset.clTab; });
  });

  function wireScroller(root){
    var sc = root.querySelector('[data-cl-track]');
    var dots = root.querySelectorAll('[data-cl-dot]');
    if (!sc || !dots.length) return;
    function sync(){
      var i = Math.round(sc.scrollLeft / (sc.scrollWidth / sc.children.length));
      dots.forEach(function(d, n){ d.setAttribute('aria-current', String(n === Math.min(i, dots.length - 1))); });
    }
    sc.addEventListener('scroll', function(){ window.requestAnimationFrame(sync); }, { passive:true });
    dots.forEach(function(d, n){ d.addEventListener('click', function(){
      var child = sc.children[n]; if (child) sc.scrollTo({ left: child.offsetLeft - sc.offsetLeft, behavior:'smooth' });
    });});
    sync();
  }
  function init(){ document.querySelectorAll('[data-cl-scroller]').forEach(wireScroller); }
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  init();

  function wireSticky(){
    var bar = document.querySelector('[data-cl-sticky]');
    var anchor = document.querySelector('[data-cl-atc-anchor]');
    if (!bar) return;
    if (!anchor){ bar.classList.add('is-on'); return; }
    var io = new IntersectionObserver(function(en){
      bar.classList.toggle('is-on', !en[0].isIntersecting && en[0].boundingClientRect.top < 0);
    }, { threshold: 0 });
    io.observe(anchor);
  }
  document.addEventListener('DOMContentLoaded', wireSticky);
  document.addEventListener('shopify:section:load', wireSticky);
  wireSticky();

  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-cl-sticky-submit]');
    if (!b) return;
    e.preventDefault();
    var form = document.querySelector('[data-cl-product-form]');
    if (!form) return;
    if (form.getBoundingClientRect().top < 0 || form.getBoundingClientRect().bottom > innerHeight){
      window.scrollTo({ top: form.getBoundingClientRect().top + scrollY - 90, behavior:'smooth' });
    }
    if (form.requestSubmit) form.requestSubmit(); else form.submit();
  });

  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-cl-qty]');
    if (!b) return;
    var input = b.parentElement.querySelector('input');
    var v = parseInt(input.value || '1', 10);
    input.value = Math.max(1, v + (b.dataset.clQty === 'up' ? 1 : -1));
    input.dispatchEvent(new Event('change', { bubbles:true }));
  });
})();
